<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>

        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>Profit and Loss Statement</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3 clearfix">
                    <div class="d-inline-block float-right ml-2">
                        <button v-on:click="viewDetails()" class="btn btn-primary position-static mr-3">Preview Report</button>
                        <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                    </div>
                </div>
            </div>
        </div>


        <b-modal id="bv-modal-PLR" size="sm" hide-footer title="Yearly Payroll Report">
            <div>No data available for that date range!</div>
        </b-modal>

        <b-modal id="profit-loss-report" dialog-class="modal-lg" size="lg" scrollable  hide-footer title="Company Profit and Loss Statement">
             <b-overlay  rounded="sm">
                <div class="text-center">
                <span class="d-block text-center">{{report_data.company_name}}</span>
                <span class="d-block text-center mb-3">{{report_data.title}}</span>
                </div>
                <table class="table">
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg">
                            <td>Income</td>
                            <td>
                                <table class="table">
                                    <tr>
                                        <td class="2">Interest on investment</td>
                                        <td class="2 text-right">{{formatMoney(details.interest_on_investment)}}</td>

                                    </tr>
                                    <tr>
                                        <td class="2">Investment loss (if occurs)</td>
                                        <td class="2 text-right">({{formatMoney(details.interest_loss)}})</td>
                                    </tr>
                                    <tr>
                                        <td class="2">Interest on Bank Account</td>
                                        <td class="2 text-right">{{formatMoney(details.interest_on_bank_account)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="2 font-wight-blod">Total Income</td>
                                        <td class="2 font-wight-blod text-right">{{formatMoney(details.income_total)}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td>Expenditure</td>
                            <td>
                                 <table class="table">
                                    <tr>
                                        <td class="2">Bank charge and excise duty</td>
                                        <td class="2 text-right">({{formatMoney(details.bank_charge_and_excise_duty)}})</td>
                                    </tr>
                                    <tr>
                                        <td class="2">AIT on interest income</td>
                                        <td class="2 text-right">({{formatMoney(details.ait_on_interest_income)}})</td>
                                    </tr>
                                    <tr>
                                        <td class="2">Total Expenditures</td>
                                        <td class="2 text-right">({{formatMoney(details.expenditure_total)}})</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>


                        <tr class="table-row hover-bg">
                            <td>Net income credited to:</td>
                            <td>
                                 <table class="table">
                                    <tr>
                                        <td class="2">Members' contribution</td>
                                        <td class="2 text-right">{{formatMoney(details.member_contribution)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="2">Company's contribution</td>
                                        <td class="2 text-right">{{formatMoney(details.company_contribution)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="2 font-wight-blod">Net income</td>
                                        <td class="2 font-wight-blod text-right">{{formatMoney(details.net_income)}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>


                    </tbody>
                </table>
                <div class="text-center">
                    <span class="d-block text-center mb-3">All operating expenses such as salary and allowances, printing & stationary, <br>printing fess, rent, legal & professional fees, audit fees borne by employer</span>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl' , 'flag','leaver'],
        components: {

        },
        data(){

            return {

                pageUrl:this.$api_url,

                search:'',
                length: 100,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',

                start_year : '',
                currentYear: new Date().getFullYear(),
                currentMonth:new Date().getMonth(),
                start_month: '',
                start_month_name: '',
                loader: false,
                showoverlay : true,

                payroll_reporting_data : [],
                details : [],
                report_data:[],

                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],
                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',


            }
        },
        methods:{

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {

                    }
                }).then(function(response){
                    this.payroll_reporting_data = response.data;
                    //console.log(this.payroll_reporting_data);

                }.bind(this));
            },
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                let url = ''

                url = this.$api_url + '/pf/report/profit-loss';

                let formData = new FormData();
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                let currentObj = this;
                axios.post(url, formData).then(function (response)
                {
                    var fileURL = response.data;
                    this.download_file(fileURL);
                    this.loader = false;

                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.$bvModal.show('bv-modal-YPR');
                        this.loader = false;
                    }
                });
                return false;
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                }
                return val.join(' ');
            },
            viewDetails: function()
            {
                if(!this.checkNet()) return false;

                var months = ["", "January", "February", "March", "April", "May", "June",
           "July", "August", "September", "October", "November", "December" ];


                let formData = new FormData();
                formData.append('year', this.start_year);
                formData.append('viewmode', 1);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                let url = this.$api_url + '/pf/report/profit-loss';

                let currentObj = this;
                axios.post(url, formData).then(function (response)
                {
                    var list_data = response.data;
                    this.report_data = list_data;
                    this.details = this.report_data.data;
                    this.loader = false;

                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.$bvModal.show('bv-modal-PLR');
                        this.loader = false;
                    }
                });



                this.$bvModal.show('profit-loss-report');


            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },
            stringView(str) {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            this.start_year = this.currentYear;
            this.start_month = this.currentMonth + 1;
            this.getPayrollReporting();
        },
        computed:
        {
            years () {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },
            filteredData()
            {
                let filtered_list = this.details;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

        }
    }
</script>

<style>

.d-inline-block.trz_fields.trz-custom-dropdown.mb-1 button {
	position: relative !important;
	bottom: 0 !important;
}
/*
.trz_pr_y
{

}
*/

</style>
